import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';

window.addEventListener('DOMContentLoaded', () => {
    const swiperLabels = new Swiper('.swiper-labels', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        wrapperClass: 'swiper-wrapper-labels',
        slideClass: 'wp-block-image',
        slideActiveClass: 'active',
        navigation: {
            prevEl: '.mobile-pagination-previous',
            nextEl: '.mobile-pagination-next',
        },
        loop: true,
        breakpoints: {
            970: {
                slidesPerView: 3,
                initialSlide: 1,
            },
            599: {
                slidesPerView: 2,
                centeredSlides: true,
            },
        },
    });
});
